/**
 * PRODUCT ACCORDION MOTION
 * Native <details>/<summary> toggles instantly with no way to transition —
 * closed content isn't laid out at all, so CSS alone can't animate it.
 * This measures the details element's own height before/after and animates
 * that with the Web Animations API, restoring the real `open` attribute at
 * the end so keyboard/screen-reader behavior and the native :open selector
 * stay exactly correct throughout — not a visual-only hack.
 * Scoped to the product page's own accordion; a no-op everywhere else.
 */
(function () {
  function setup(details) {
    var summary = details.querySelector(':scope > summary');
    var content = details.querySelector(':scope > .accordion__content');
    if (!summary || !content) return;

    var animation = null;
    var isClosing = false;
    var isExpanding = false;

    function onFinish(willBeOpen) {
      details.open = willBeOpen;
      animation = null;
      isClosing = false;
      isExpanding = false;
      details.style.height = '';
      details.style.overflow = '';
    }

    function shrink() {
      isClosing = true;
      var startHeight = details.offsetHeight + 'px';
      var endHeight = summary.offsetHeight + 'px';
      if (animation) animation.cancel();
      animation = details.animate({ height: [startHeight, endHeight] }, { duration: 300, easing: 'ease-out' });
      animation.onfinish = function () { onFinish(false); };
      animation.oncancel = function () { isClosing = false; };
    }

    function expand() {
      isExpanding = true;
      var startHeight = details.offsetHeight + 'px';
      var endHeight = summary.offsetHeight + content.offsetHeight + 'px';
      if (animation) animation.cancel();
      animation = details.animate({ height: [startHeight, endHeight] }, { duration: 300, easing: 'ease-out' });
      animation.onfinish = function () { onFinish(true); };
      animation.oncancel = function () { isExpanding = false; };
    }

    function open() {
      details.style.height = details.offsetHeight + 'px';
      details.style.overflow = 'hidden';
      details.open = true;
      window.requestAnimationFrame(expand);
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      details.style.overflow = 'hidden';
      if (isClosing || !details.open) {
        open();
      } else if (isExpanding || details.open) {
        shrink();
      }
    });
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (typeof Element.prototype.animate !== 'function') return; // no WAAPI, fall back to native toggle
    document.querySelectorAll('.product .product__accordion.accordion > details, .candy-faq .accordion > details').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
